import { render } from "./delete-svg.vue?vue&type=template&id=56da9f28"
import script from "./delete-svg.vue?vue&type=script&lang=js"
export * from "./delete-svg.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__